import React from 'react';

export default function NewArrivals() {
  return (
    <div className="min-h-screen bg-black text-white py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-4xl md:text-5xl font-bold text-white mb-4" style={{ fontFamily: 'serif' }}>
          New Arrivals
        </h1>
        <p className="text-gray-400">New arrivals coming soon...</p>
      </div>
    </div>
  );
}
